import { Outlet, useLocation } from 'react-router-dom';
import { Box, Flex, Link } from '@gusto/workbench';
import trackSignInClicked from 'packages/signup/analytics/trackSignInClicked';
import plantShopEmployeesSvg from '../../../../../images/signupV2/plant_shop_employees.svg';
import plantShopEmployeeCroppedSvg from '../../../../../images/signupV2/plant_shop_employee_cropped.svg';
import ProgressBar from '../../../../components/progress_bar';
import { useSignupContext } from '../signupProvider';
import calculateProgressPercentage from './progressPercentageCalculation';

export default function AccountantsInviteLayout({
  accountingFirmName,
  accountingFirmLogoUrl,
}: {
  accountingFirmName: string;
  accountingFirmLogoUrl: string | undefined;
}) {
  const signupContext = useSignupContext();
  const { pathname } = useLocation();

  const showingForm = pathname.includes('/sign_up_form');

  return (
    <>
      <section className="single-page-variant-1">
        <Flex width="100wh" flexDirection="column" flexDirectionMd="row">
          {!showingForm && (
            <ProgressBar
              percentage={calculateProgressPercentage(signupContext)}
              headerId="#lead-nav"
            />
          )}
          <Flex
            heightMd="100vh"
            widthLg="50%"
            widthMd="54%"
            flexDirection="column"
            alignItems="center"
            justifyContent="space-between"
            className={`get-started-box ${showingForm ? '' : 'white-background'}`}
          >
            {showingForm ? (
              <Box textAlign="center" marginTop="20px">
                <h2>Thanks!</h2>
                <p className="layout-subheading">
                  Finish creating your account and don’t pay a cent until you run your first
                  payroll.
                </p>
              </Box>
            ) : (
              <Box textAlign="center" paddingTop="20px" paddingLeft="20px" paddingRight="20px">
                {accountingFirmLogoUrl && (
                  <img
                    src={accountingFirmLogoUrl}
                    alt={`${accountingFirmName} Logo`}
                    style={{ maxHeight: '48px', maxWidth: '200px' }}
                  />
                )}
                <h1 className="h2 text-center margin-bottom-10px margin-top-30px">
                  See how easy payroll and benefits can be
                  <br />
                  with Gusto &amp; {accountingFirmName}
                </h1>
                <p className="text-default grey-text">
                  Already use Gusto?{' '}
                  <Link onClick={trackSignInClicked} href="/login">
                    Sign in
                  </Link>
                </p>
              </Box>
            )}
            <img
              className="plant-shop"
              alt="Happy employees in a plant shop"
              src={plantShopEmployeesSvg}
            />
            {!showingForm && (
              <img
                className="plant-shop-cropped"
                alt="Happy employee in a plant shop"
                src={plantShopEmployeeCroppedSvg}
              />
            )}
          </Flex>
          <Flex
            widthLg="50%"
            widthMd="46%"
            alignItems="center"
            justifyContent="center"
            overflow="scroll"
            className="question-box"
            backgroundColor={showingForm ? '' : 'salt.200'}
          >
            <Outlet />
          </Flex>
        </Flex>
      </section>
    </>
  );
}
